import ScrollAnimation from '../../../components/base/ScrollAnimation';

export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-sun-line',
      title: 'UV Protection',
      description: 'Block up to 99% of harmful UV rays, protecting your skin and preventing interior fading and cracking.',
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'Heat Rejection',
      description: 'Reduce interior temperature by up to 60%, keeping your vehicle cooler and reducing AC usage.',
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Privacy & Security',
      description: 'Enhanced privacy for you and your belongings while deterring theft and break-ins.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Shatter Protection',
      description: 'Film holds glass together in case of accidents, providing an extra layer of safety.',
    },
    {
      icon: 'ri-contrast-2-line',
      title: 'Glare Reduction',
      description: 'Minimize eye strain and improve visibility by reducing harsh sunlight and headlight glare.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Increased Value',
      description: 'Preserve your vehicle\'s interior and enhance resale value with professional tinting.',
    },
  ];

  return (
    <section className="py-24 max-md:py-8 bg-secondary text-white relative overflow-hidden mobile-compact-section">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '50px 50px',
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation animation="fade-in">
          <div className="text-center mb-16 max-md:mb-6 mobile-compact-spacing">
            <h2 className="text-4xl md:text-5xl max-md:text-2xl font-bold mb-4 max-md:mb-2">
              Why Choose Window Tinting?
            </h2>
            <p className="text-xl max-md:text-sm text-gray-300 max-w-3xl mx-auto mobile-compact-text">
              Professional window tinting offers numerous benefits beyond aesthetics. Protect your investment and enhance your driving experience.
            </p>
          </div>
        </ScrollAnimation>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-md:gap-4 mobile-compact-gap">
          {benefits.map((benefit, index) => (
            <ScrollAnimation key={benefit.title} animation="slide-up" delay={index * 100}>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl max-md:rounded-lg p-6 max-md:p-3 border border-white/10 hover:bg-white/10 transition-all duration-300 hover:transform hover:-translate-y-1">
                <div className="w-16 h-16 max-md:w-10 max-md:h-10 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mb-4 max-md:mb-2">
                  <i className={`${benefit.icon} text-3xl max-md:text-xl text-white`}></i>
                </div>
                <h3 className="text-xl max-md:text-base font-bold mb-3 max-md:mb-1">{benefit.title}</h3>
                <p className="text-gray-300 max-md:text-xs leading-relaxed mobile-compact-text">{benefit.description}</p>
              </div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
}
